export enum OBJECT_FIELD_TYPE {
  ENUM = 'enum',
  SINGLE = 'single',
  OBJECT_LINK = 'object_link',
  ARRAY = 'array',
}

export enum FIELD_VALUE_FORMAT {
  NUMBER = 'NUMBER',
  TIME = 'TIME',
  BOOLEAN = 'BOOLEAN',
}

export const EXPAND_FIELD_PREFIX = 'expands_'

export enum DURATION_UNIT {
  MILLISECONDS = 'MILLISECONDS',
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
  YEARS = 'YEARS',
}

export const LARGE_DURATION_UNITS: DURATION_UNIT[] = [
  DURATION_UNIT.DAYS,
  DURATION_UNIT.WEEKS,
  DURATION_UNIT.MONTHS,
  DURATION_UNIT.YEARS,
]
